import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'components/Modals/actions';
import { isNonEmptyArray } from 'utils/arrays';

const useModal = () => {
  const dispatch = useDispatch();
  const { modalType, stackedModals } = useSelector(state => state?.modals);

  return {
    isModalVisible: Boolean(modalType) || isNonEmptyArray(stackedModals),
    // showModal, hideModal, refreshModalProps
    ...bindActionCreators({ ...actions }, dispatch),
  };
};

export default useModal;
